export default {"src":"/_next/static/media/EL.8657f2af.svg","height":18,"width":18};